import React from 'react';

export const BOSS = () => {
  return (
    <div className="store__message">
      <div className="store__icon">
        <img src="https://assets.homedepot-static.com/images/v1/In-Stock.svg" alt="Available for pickup" />
      </div>
      <div className="store__text-box">
        <div>Pickup</div>
        <div className="store__second-line">
          <span className="store__success">{'Free '}</span>
          <span className="store__primary">ship to store</span>
        </div>
      </div>
    </div>
  );
};
